import * as types from '../mutation-types';
import { permissionNames } from '@/helpers/enums';

export default {
	namespaced: true,
	state: {
		authenticated: false,
		userData: {
			name: null,
			employeeType: null
		},
		self: {
			username: null,
			employeeId: null,
		},
	},

	actions: {
		updateLastLogin({ commit }, { userId, platformUsed }) {
			return window.axios.put('/users/lastSignIn', {}, { 
				params: { userId, platformUsed },
				// لا تُلغي عند تغيير الصفحة
				preventRouteAbort: true  
			}).then((data) => {
				return data
			})
		},

		login({ commit, dispatch }, { username, password }) {
			return window.axios.post('/users/authenticate', { username, password })
				.then((response) => {
				/* 
				the following (if statement) is to check if how is logging in is medical rep
				and if medical rep log in will throw exciption with message and (name=42)
				*/
					if (response.data.userType !== 1) {
						const e = new Error('It is ALLOWED ONLY to medical reps to enter the app');
						e.name = 42;
						throw e;
					}

					const auth = {
						username, employeeId: response.data.employeeId, token: response.data.token, authenticated: true
					};
	
					localStorage.setItem('auth', JSON.stringify(auth));
					window.axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.token;
					return dispatch('getSelf').then((response) => {
						commit(types.LOGIN, auth);
						return response.data;
					})
				// dispatch('users/getself', null, { root: true }).then(() => {
				// 	commit(types.LOGIN, auth);
				// });
				})
		},
	
		logout({ commit }) {
			localStorage.removeItem('auth');
			delete window.axios.defaults.headers.common.Authorization;
			commit(types.LOGOUT);
		},

		getSelf({ commit, dispatch }) {
			return	window.axios.get('/users/getself').then((response) => {
				// platformUsed ios 2
				dispatch('updateLastLogin', { userId: response.data.id, platformUsed: 2 })
				commit(types.GET_USER_DATA, response.data)
				return response.data;
			})
		},
	},

	mutations: {
		[types.GET_USER_DATA](state, userData) {
			state.userData = userData;
		},

		[types.LOGIN](state, payload) {
			state.authenticated = true;
			state.self.username = payload.username;
			state.self.employeeId = payload.employeeId;
		},
	
		[types.LOGOUT](state) {
			state.authenticated = false;
			state.self.username = null;
			state.self.employeeId = null;
		},
	},

	getters: {
		isAdmin: state => state.userData.employeeType === 2,

		// rep type based on permissions from /users/getself
		// userData.role.permissions[].permissionsNames[]
		// MarketingVisits (34) = Marketing, ScientificVisits (35) = Scientific
		// rolePermissions: 0 = no access, 1/2 = has access
		repType: state => {
			const permissionGroups = state.userData?.role?.permissions || []
			const hasAccess = value => {
				const numericValue = Number(value)
				return numericValue === 1 || numericValue === 2
			}

			const getPermissionKey = permission => {
				const value = permission?.permissionId ??
					permission?.permission?.id ??
					permission?.permissionsNames ??
					permission?.id

				const numericValue = Number(value)
				return Number.isFinite(numericValue) ? numericValue : null
			}

			const permissionEntries = permissionGroups.flatMap(group => {
				const groupPermissionId = getPermissionKey(group)
				const groupRolePermission = group?.rolePermissions ?? group?.rolePermission ?? 0
				const names = Array.isArray(group?.permissionsNames) ? group.permissionsNames : []

				if (!names.length) {
					return [{
						permissionId: groupPermissionId,
						rolePermissions: groupRolePermission,
					}]
				}

				return names.map(item => ({
					permissionId: getPermissionKey(item) || groupPermissionId,
					rolePermissions: item?.rolePermissions ?? item?.rolePermission ?? groupRolePermission,
				}))
			})

			const canMarketing = permissionEntries.some(
				entry => entry.permissionId === permissionNames.MarketingVisits && hasAccess(entry.rolePermissions)
			)
			const canScientific = permissionEntries.some(
				entry => entry.permissionId === permissionNames.ScientificVisits && hasAccess(entry.rolePermissions)
			)

			if (canMarketing && canScientific) return 'Both'
			if (canMarketing) return 'Financial'
			if (canScientific) return 'Scientific'
			return 'None'
		},

		getUserType: state => {
			if (state.userData.employeeType === 0) return 'supervisor'
			else if (state.userData.employeeType === 1) return 'medical rep'
			else if (state.userData.employeeType === 2) return 'admin'
		}
	},

	modules: {
	},
}